import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ErrorPageComponent} from './components/error-page/error-page.component';
import {TranslatePipe} from '@ngx-translate/core';
import {SharedModule} from '../shared/shared.module';
import {ErrorAuthComponent} from './components/not-authorized/error-auth.component';

@NgModule({
  declarations: [ErrorPageComponent, ErrorAuthComponent],
  imports: [CommonModule, SharedModule],
  providers: [TranslatePipe]
})
export class ErrorPageModule {}
